import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import TagManager from 'react-gtm-module';
import 'bootstrap/dist/css/bootstrap.min.css';
import { persistEntryUrl } from './helpers/entryUrl';

// Capturar la URL de entrada ANTES de que React se inicialice
// Esto asegura que guardamos la URL original con parámetros UTM, etc.
persistEntryUrl();

const tagManagerArgs = {
    gtmId: 'GTM-PQVG8JT9',
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
